__turbopack_context__.v({
  "richText": "ePsLSa_richText",
});
